import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isClarityPage, stopClarity } from '@/lib/clarity';

/**
 * Microsoft Clarity records the sign-in / sign-up pages only. Watches the route (any way of leaving: a
 * completed sign-in, a link, the back button) and stops the Clarity session as soon as the path isn't one of
 * those pages. Route-based rather than a page unmount, so React's StrictMode double effects can't stop it early.
 */
export const ClarityRouteGuard = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!isClarityPage(pathname)) stopClarity();
  }, [pathname]);
  return null;
};
